/** @format */

import React, { FunctionComponent, ReactElement, useState } from 'react';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import { Button } from '@material-ui/core';
import CardBody from '../../../components/Card/CardBody';
import Card from '../../../components/Card/Card';
import I18n from '../../../components/Translate/I18n';
import Loader from '../../../components/Loaders/Loader';
import CustomInputExtNumber from '../../../components/CustomInput/CustomInputExtNumber';
import { usePlatformResellerHeaders, usePlatformResellerList } from '../../../modules/lib/hooks/usePlatformResellerHooks';
import { SimpleSelect } from '../../../components/Adescom/SimpleSelect';
import { useDispatch } from 'react-redux';
import { notificationConstants } from '../../../modules/notifications/notifications';
import { apiCall } from '../../../core/apiCall';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import CustomInputExt from '../../../components/CustomInput/CustomInputExt';
import { withStyles } from '@material-ui/core/styles';
import oplAppStyle from '../../../assets/themes/OPL/jss/App/OplAppStyle';
import CustomTextButton from '../../../components/Buttons/CustomTextButton';
import CardHeader from '../../../components/Heading/CardHeaderExt';

const _ = require('underscore');

type UploadMsisdnPoolFileType = {
    classes: any;
    showMainLoader: (show: boolean) => void;
    reloadList: (relaod: boolean) => void;
    poolType: string;
};

const UploadMsisdnPoolFile: FunctionComponent<UploadMsisdnPoolFileType> = ({ classes, showMainLoader, reloadList, poolType }): ReactElement => {
    const dispatch = useDispatch();
    const [visibleLoader, setVisibleLoader] = useState<boolean>(false);
    const [hideUpload, setHideUpload] = useState(true);
    const [file, setFile] = useState<File | null>(null);
    const [rangeFrom, setRangeFrom] = useState<string | null>('');
    const [rangeTo, setRangeTo] = useState<string | null>('');
    const [platformResellerId, setPlatformResellerId] = useState<number | null>(null);

    const platformResellerList = usePlatformResellerList([]);
    const platformResellerHeader = usePlatformResellerHeaders(platformResellerList);

    const selectFile = (event: any): void => {
        const file = event.target.files[0];
        setFile(file);
        setHideUpload(false);
    };

    const upload = (): void => {
        if (!platformResellerId && poolType !== 'ip') {
            dispatch({
                type: notificationConstants.CUSTOM_NOTIFY,
                message: 'pools:msisdn.partner_not_provided',
                variant: 'error',
            });
            return;
        }
        if (file) {
            const data = new FormData();
            data.append('file', file);
            data.append('rangeFrom', rangeFrom ?? '');
            data.append('rangeTo', rangeTo ?? '');
            data.append('poolType', poolType);
            if (platformResellerId) {
                data.append('platformResellerId', platformResellerId.toString());
            }
            showMainLoader(true);
            apiCall
                .uploadFile(FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/platform_pools_files')), data)
                .then((response: any): void => {
                    setFile(null);
                    setPlatformResellerId(null);
                    setRangeFrom(null);
                    setRangeTo(null);
                    setHideUpload(true);
                    reloadList(true);
                    showMainLoader(false);
                    dispatch({
                        type: notificationConstants.CUSTOM_NOTIFY,
                        message: 'pools:msisdn.pools_was_added',
                        variant: 'success',
                    });
                })
                .catch((error: any): any => {
                    showMainLoader(false);
                    dispatch({ type: notificationConstants.ERROR });
                });
        }
    };

    const onChangeEvent = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const value = event.target.value;
        const field = event.target.name;
        switch (field) {
            case 'rangeFrom':
                setRangeFrom(value);
                break;
            case 'rangeTo':
                setRangeTo(value);
                break;
            default:
                break;
        }
    };

    const setPlatformResellerCallback = (event: React.ChangeEvent<HTMLSelectElement>): void => {
        setPlatformResellerId(parseInt(event.target.value));
    };

    return (
        <Card>
            {!hideUpload ? <CardHeader trans="pools:msisdn.fill_data" /> : null}
            <CardBody>
                {!hideUpload && (
                    <GridItem xs={12}>
                        <GridContainer>
                            {poolType !== 'ip' && (
                                <GridItem xs={12}>
                                    <SimpleSelect
                                        label="pools:msisdn.choose_partner"
                                        required={true}
                                        elements={platformResellerHeader ?? []}
                                        fieldName="platformResellerId"
                                        dispatchName={'none'}
                                        selectedValue={platformResellerId ?? undefined}
                                        callback={setPlatformResellerCallback}
                                    />
                                </GridItem>
                            )}
                            {poolType === 'msisdn' && (
                                <React.Fragment>
                                    <GridItem xs={6}>
                                        <CustomInputExtNumber
                                            formControlProps={{ fullWidth: true }}
                                            required={false}
                                            labelText="pools:msisdn.range_from"
                                            name="rangeFrom"
                                            value={rangeFrom}
                                            onChange={onChangeEvent}
                                        />
                                    </GridItem>
                                    <GridItem xs={6}>
                                        <CustomInputExtNumber
                                            formControlProps={{ fullWidth: true }}
                                            required={false}
                                            labelText="pools:msisdn.range_to"
                                            name="rangeTo"
                                            value={rangeTo}
                                            onChange={onChangeEvent}
                                        />
                                    </GridItem>
                                </React.Fragment>
                            )}
                            {(poolType === 'ip' || poolType === 'imsi') && (
                                <React.Fragment>
                                    <GridItem xs={6}>
                                        <CustomInputExt
                                            formControlProps={{ fullWidth: true }}
                                            required={false}
                                            labelText="pools:msisdn.range_from"
                                            name="rangeFrom"
                                            value={rangeFrom}
                                            onChange={onChangeEvent}
                                        />
                                    </GridItem>
                                    <GridItem xs={6}>
                                        <CustomInputExt
                                            formControlProps={{ fullWidth: true }}
                                            required={false}
                                            labelText="pools:msisdn.range_to"
                                            name="rangeTo"
                                            value={rangeTo}
                                            onChange={onChangeEvent}
                                        />
                                    </GridItem>
                                </React.Fragment>
                            )}
                        </GridContainer>
                    </GridItem>
                )}
                <GridItem xs={12}>
                    <label htmlFor="btn-upload">
                        <input
                            id="btn-upload"
                            name="btn-upload"
                            style={{ display: 'none' }}
                            type="file"
                            onChange={selectFile}
                            accept="text/csv, .csv"
                        />
                        <Button className={`${classes.button} ${classes.lg} ${!hideUpload ? '' : classes.primary}`} component="span">
                            <I18n trans="pools:msisdn.choose_msisdn_pools_files" />
                        </Button>
                    </label>
                    {!hideUpload && (
                        <CustomTextButton
                            size={'lg'}
                            color={'primary'}
                            label={'pools:msisdn.wpload_msisdn_pools_files'}
                            callback={upload}
                            callbackParam={{}}
                        />
                    )}
                </GridItem>
                <Loader visible={visibleLoader} />
            </CardBody>
        </Card>
    );
};

export default withStyles(oplAppStyle)(UploadMsisdnPoolFile);
